<div class="login">
  <h1 class="visually-hidden">Login</h1>
  <div class="login__card">
    <img class="login__card__logo" [src]="client.getInvertedLogoURL()"
      alt="{{client.getSiteName()}}">

    <h2 class="login__card__heading"
    [innerText]="'Welcome to Your Total Rewards Statement' | translate"></h2>

    <p class="login__card__subheading"
      [innerText]="'View a personalized statement of your total benefits, rewards and compensation.' |translate">
    </p>

    <form [formGroup]="loginForm" (ngSubmit)="captchaRef.execute()" novalidate>
      <div class="form-group"
        [ngClass]="{'form-group--success': loginForm.get('accessCode')!.valid,
           'form-group--error': loginForm.get('accessCode')!.touched && !loginForm.get('accessCode')!.valid}">
        <div>
          <label for="accessCode">Please enter your access code</label>
          <div class="form-control-wrapper">
            <input id="accessCode" #accessCode type="password" formControlName="accessCode"
              name="uid" class="form-control form-control-lg" autocomplete="new-password"
              maxlength="32" coreAutoFocus />
            <span class="valid-feedback form-control-feedback"
              [hidden]="!loginForm.get('accessCode')!.valid" aria-live="polite"><span
            class="visually-hidden">Correct</span></span>
          </div>
        </div>
      </div>

      @if (errorMessage) {
        <div class="login__card__error">
          <h4 class="login__card__error__heading">Login Failed</h4>
          <span [innerHTML]="errorMessage"></span>
        </div>
      }

      <button id="js-login-btn" class="btn--clean-green" [class.spinner]="loading"
        [disabled]="loading || !loginForm.valid">
        <core-spinner name="login"></core-spinner>
        @if (!loading) {
          <span [innerText]="'Login' | translate"></span>
        }
        @if (loading) {
          <span [innerText]="'Logging in...' | translate"></span>
        }

        <img src="/assets/img/icons/right-arrow-icon.svg" alt="" />
      </button>

      <re-captcha size="invisible" #captchaRef="reCaptcha"
      (resolved)="$event && login($event)"></re-captcha>

      <div class="login__card__caption">
        <img src="assets/img/icons/info-icon.svg" alt="Note:" />
        <span class="login__card__caption__body">If you are logged into the SOLV Energy network, you
          may click login and be connected
        via single sign-on above.</span>
      </div>

      <div class="login__card__help">
        <h3 class="login__card__help__heading" [innerText]="'Need help?' | translate"></h3>
        <span class="login__card__help__body">If you need help logging in, please contact your SOLV
          HR Team at <a href="mailto:benefits@solvenergy.com">benefits&#64;solvenergy.com</a></span>
        </div>

      </form>
    </div>

    <div class="login__footer">
    <span [innerHTML]="'&copy; ' + currentYear +
        ' Gallagher | All Rights Reserved.' + ' Powered by Core.'"></span>
    </div>
  </div>
